import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import allFields from '@/formInputs.js'

const initStore = () => {
  let initState = {}

  const laborInitValue = {
    normal_min: null,
    normal_max: null,
    mertekegyseg: null,
    ertek: null,
  }

  for (let group in allFields) {
    for (let subgroup in allFields[group]) {
      if ('key' in allFields[group][subgroup]) {
        initState[subgroup] = null
      } else {
        for (let key in allFields[group][subgroup]) {
          initState[key] = allFields[group][subgroup][key]['type'] === 'labor' ? laborInitValue : null
        }
      }
    }
  }
  return initState
}

export default new Vuex.Store({
  state: {
    formInputs: initStore(),
    user: localStorage.getItem('user', null)
  },
  getters: {
    getFormInputs: (state) => {
      return state.formInputs
    },
    getUser: (state) => {
      return state.user
    }
  },
  mutations: {
    setFormInput: (state, payload) => {
      state.formInputs[payload.key] = payload.value
    },
    signUserIn: (state, payload) => {
      state.user = payload
    },
    signUserOut: (state) => {
      state.user = null
    }
  },
  actions: {
    setFormInput: ({ commit }, payload) => {
      commit('setFormInput', payload)
    },
    signUserIn: ({ commit }, payload) => {
      commit('signUserIn', payload)
      localStorage.setItem('user', payload)
    },
    signUserOut: ({ commit }) => {
      commit('signUserOut')
      localStorage.removeItem('user')
    }
  }
})
